// ----------------------------------------------------------------------------
// Component: Tabs
// ----------------------------------------------------------------------------
// Accordion / Tabs pattern from Bourbon (http://refills.bourbon.io/)

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

module.exports = function() {

    // Open the first tab by default
    $('.tabs').each(function(index) {
        $(this).children('li.tab').first().addClass('tab--active');
    });

    // Bind click events to navigate between tabs
    $('.tabs').on('click', 'li > a.tab__link', function(event) {

        var tab = $(this).parents('li.tab');
        var tabGroup = $(this).parents('ul.tabs');

        if (!tab.hasClass('tab--active')) {
            event.preventDefault();

            // Close All Tabs
            tabGroup.find('li.tab').removeClass('tab--active');

            // Open the Selected Tab
            tab.addClass('tab--active');
        } else {
            event.preventDefault();
        }
    });

};
